/**
 * 考试数据中心
 */

 export const ExamReportList = [{
    prop: "id",
    label: "id",
    width: "150",
    format: "",
    order: false,
    isShow: false,
  },
  {
    prop: "name",
    label: "试卷名称",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "categoryName",
    label: "试卷分类",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "startTime",
    label: "开始时间",
    width: "150",
    format: "datetime",
    order: false,
    isShow: true,
  },
  {
    prop: "endTime",
    label: "结束时间",
    width: "150",
    format: "datetime",
    order: false,
    isShow: true,
  },
  {
    prop: "participationCount",
    label: "参与次数",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "passCount",
    label: "及格人数",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "totalCount",
    label: "参考人数",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  }
];